<div class="m-30" style="position: relative; 
padding-top: 40px;
">
    <div style="position: absolute; top: 0px; right: 10px;">
        <button style="padding: 8px  !important;
        background-color: var(--mat-sys-surface-variant);
        border-radius: 50%; display: flex; align-items: center; justify-content: center;
        width: 30px; height: 30px; cursor: pointer; border: none; outline: none;
        " *ngIf="dialogRef" (click)="closeWithConfirm()">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px">close</mat-icon>
        </button>
    </div>
    <mat-stepper [linear]="false">
        <mat-step [stepControl]="firstStepGroup" [completed]="areAllChecklistTrue()"
            errorMessage="Complete all checklist items before proceeding">
            <ng-template matStepLabel>CheckLists</ng-template>
            <div class="py-20">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>
                            *Encounter Initiation – Mandatory Provider Checklist*
                        </mat-card-title>
                        <mat-card-subtitle>
                            Check the following boxes to ascertain that the corresponding actions / precautions have
                            been taken
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="py-20">
                            <ul>
                                @for(check of encounterCheckList; track $index;){
                                <li style="margin-bottom: 12px; font-size: 1rem;">
                                    {{check}}
                                </li>
                                }
                            </ul>
                        </div>
                        <div class="py-20">
                            <!-- @for(list of encounterCheckList; track $index;){ -->
                            <p>
                                <mat-slide-toggle labelPosition="after" [formControl]="checkListRep" class="me-8">
                                    <span style="font-size: 1.1rem; margin-left: 0px;">
                                        I confirm that I have completed all the above encounter initiation steps and
                                        acknowledge that this information is accurate
                                    </span>
                                </mat-slide-toggle>
                            </p>
                            <!-- } -->
                            <div class="my-10" *ngIf="areAllChecklistTrue()"
                                style="color: var(--mat-sys-primary); font-weight: 500;">
                                All mandatory checklist items have been completed.
                            </div>


                        </div>
                    </mat-card-content>

                </mat-card>
            </div>
            <div class="g-just-flex gap-12 justify-content-between" style="width:100%;">

                <button mat-flat-button matStepperNext [disabled]="firstStepGroup.invalid">Next</button>
            </div>
        </mat-step>
        <!-- <mat-step>
            <ng-template matStepLabel>Patient Details</ng-template>
            <div class="forms">
                <app-add-vitals (vitalsChanged)="vitalsLatest = $event"></app-add-vitals>
                <div class="my-10" *ngIf="getMissingRequiredVitals().length"
                    style="color: var(--mat-sys-error); font-size: 0.85rem;">
                    Required vitals missing: {{getMissingRequiredVitals().join(', ')}}
                </div>
            </div>
            <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">
                <button mat-flat-button matStepperPrevious>Back</button>
                <button mat-flat-button matStepperNext [disabled]="!hasRequiredVitals()">Next</button>

            </div>
        </mat-step> -->
        <!-- //bmi stepp calculation
        <mat-step>
            <ng-template matStepLabel>BMI</ng-template>
            <div class="forms">
                <app-dynamic-forms-v2 [formFields]="bmiFormFields" [formMetaData]="bmiFormMetaData"
                    (formSubmitted)="bmiFormSubmitted($event)">

                </app-dynamic-forms-v2>
            </div>
            <div class="bmi-interprete">
                @if(bmiFormSubmittedError && !patientBMICategory){
                <div class="error-message my- 15 indicator-text g-just-flex gap-12 justify-content-start"
                    style="background-color: var(--mat-sys-surface-container); width: max-content">
                    <mat-icon>report_problem</mat-icon>
                    <span [style.color]="'var(--mat-sys-error)'"
                        [style.font-size]="'0.9rem'">{{bmiFormSubmittedError}}</span>
                </div>
                }
                @if(patientBMI && patientBMICategory){
                <div class="meter-background">
                    <div class="meter-foreground">
                        @for(band of bmiBands; track $index;){
                        <div class="band" matTooltip="{{band.category}}" [matTooltipPosition]="'above'" [ngStyle]="{'background-color': band.color, 'width': ($first || $last)? ($first?(band.bmiRange[1]! - 0): (100 - band.bmiRange[0]!))+'%':
                            (band?.bmiRange?.[1] || 100) - (band?.bmiRange?.[0] || 0) +'%'}">



                        </div>
                        }
                        <div class="position-indicator"
                            [ngStyle]="{'left': patientBMI < 100 ? patientBMI+ '%' : '98%'}">


                        </div>
                    </div>
                </div>-->
        <!-- // POSITION iNDICATOR -->

        <!-- <div class="justify-content-start gap-12 g-just-flex indicator-text">

                    <mat-icon [style.color]="patientBMICategory.color">{{patientBMICategory.icon}}</mat-icon>
                    {{patientBMI.toFixed(2)+' kg/m²'}}
                    <span class="category-text"> -->
        <!--patient-->
        <!--  {{patientBMICategory.category}}
                    </span>

                </div>

                }
            </div>
            <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">
                <button mat-flat-button matStepperPrevious>Back</button>
                <button mat-flat-button matStepperNext>Next</button>

            </div>
        </mat-step> -->
        <mat-step>
            <ng-template matStepLabel>Encounter Details</ng-template>
            <div class="forms">
                <app-dynamic-forms-v2 #detailsDF [formFields]="data!.formFieldsToUse.details">

                </app-dynamic-forms-v2>
                <!-- <div class="my-15"></div>
                <app-dynamic-forms-v2 [formFields]="data!.formFieldsToUse.reason"
                    (formSubmitted)="populateSymptoms($event)" [formMetaData]="symptomsFormMetaData" #reasonDF>

                </app-dynamic-forms-v2> -->
                <!-- {{reasonDF.aForm.value | json}} -->
            </div>
            <!-- {{encounterReasonForm.value | json}} -->
            -
            <div class="my-15"></div>
            <app-dynamic-forms-v2 #actorsDF [formFields]="data!.formFieldsToUse.actors">

            </app-dynamic-forms-v2>
            <div class="submission-arena g-just-flex flex-wrap justify-content-end gap-12 mt-20">
                <button mat-flat-button color="warn" (click)="closeWithConfirm()">Quit Without Saving</button>
                <button mat-flat-button color="primary" (click)="setEncounter()" [disabled]="!areAllChecklistTrue">
                    Submit Encounter
                </button>
            </div>
        </mat-step>
    </mat-stepper>
</div>

<!-- {{encounterReasonForm.value | json}} -->
<!-- *Encounter Initiation – Mandatory Provider Checklist*

Before proceeding with this encounter, please confirm that you have completed all required steps:
	1.	I have washed and sanitized my hands.
	2.	I greeted the patient by name.
	3.	I verified the patient’s ID using at least two identifiers.
	4.	I ensured the patient is seated or lying down comfortably.
	5. I observed the patient’s gait (where applicable).
	6.	I asked the patient about any current pain or discomfort.
	7.	I confirmed the presence of a chaperone for female patients (where required).
	8.	I reviewed the patient’s previous visit history.

☐ I confirm that I have completed all the above encounter initiation steps and acknowledge that this information is accurate. -->